import { fragments as dtgOrderStatusFragments } from "../HDDOrderStatus/graph";
import { filter } from "graphql-anywhere";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import { useRouter } from "found";
import AppBar from "../../../../../components/AppBar";
import CircularProgress from "@mui/material/CircularProgress";
import HDDOrderStatus from "../HDDOrderStatus";
import OrderDetailWithStatusHeader from "../../../../../components/OrderDetailWithStatusHeader";
import React, { useCallback } from "react";

const HDDOrderDetail = ({ orderId, appBarBackgroundColor }) => {
  const { router } = useRouter();

  const { data, loading, error } = useQuery(query, {
    skip: !orderId,
    variables: { orderId }
  });

  const handleAppBarRequestBack = useCallback(() => {
    router.push("/apps/production/hdd-press");
  }, [router]);

  const handleOrderDetailRequestClose = useCallback(() => {
    router.push("/apps/production/hdd-press");
  }, [router]);

  return (
    <OrderDetailWithStatusHeader
      destinationRoute="/apps/production/hdd-press/orders"
      errorMessage={error ? error.message : null}
      loading={loading}
      onRequestClose={handleOrderDetailRequestClose}
      order={data?.order}
      orderStatusView={
        data && data.order ? (
          <HDDOrderStatus
            order={filter(dtgOrderStatusFragments.order, data.order)}
          />
        ) : (
          <CircularProgress />
        )
      }
      shouldShowCustomerArtworkWithNotes={false}
      shouldShowInkColors={false}
      title="DTG"
      viewer={data?.viewer}
    >
      <AppBar
        title="HDD"
        onRequestBack={handleAppBarRequestBack}
        backgroundColor={appBarBackgroundColor}
      />
    </OrderDetailWithStatusHeader>
  );
};

export default HDDOrderDetail;
